import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zhCN from './locales/zh-CN/common.json';
import enUS from './locales/en-US/common.json';

// 获取保存的语言设置，如果没有则默认为中文
const savedLang = localStorage.getItem('lang') || 'zh-CN';

// 初始化 i18n
i18n
  .use(initReactI18next)
  .init({
    resources: {
      'zh-CN': { common: zhCN },
      'en-US': { common: enUS }
    },
    lng: savedLang,
    fallbackLng: 'zh-CN',
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    react: {
      useSuspense: false
    }
  });

// 类型声明，便于调试
declare global {
  interface Window {
    i18next: typeof i18n;
  }
}

if (typeof window !== 'undefined') {
  window.i18next = i18n;
}

export default i18n; 